import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import styles from "./SwitchDomainButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const SwitchDomainButton = ({ className, disabled, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled}`} onClick={onClick}>
            <MenuBookOutlinedIcon />
            <div>{"Switch Domain"}</div>
        </div>
    );
};